<div class="modal-header bg-dark">
  <h4 class="modal-title" translate>Erfassung unvollständig</h4>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="modal.dismiss()"></button>
</div>
<div class="modal-body">
  @if (!furtherActionSelectionValid) {
    <div class="mb-2">
      <div
        class="multiline"
        translate="ConfirmStatusChangeMessageInvalidFurtherActionSelection"></div>
    </div>
  }
  @if (!furtherActionSelectionValid && categoriesWithMissingDefectSeverity?.length) {
    <hr />
  }
  @if (categoriesWithMissingDefectSeverity?.length) {
    <div class="mb-2">
      <div
        class="multiline"
        [translateParams]="{ number: categoriesWithMissingDefectSeverity.length }"
        translate="ConfirmStatusChangeMessageCategoriesWithMissingDefectSeverities"></div>
      <button
        class="btn btn-link btn-details-toggle"
        (click)="
          categoriesWithMissingDefectSeverityDetailsCollapsed =
            !categoriesWithMissingDefectSeverityDetailsCollapsed
        "
        aria-expanded="!categoriesWithMissingDefectSeverityDetailsCollapsed"
        aria-controls="collapse-missing-severity-details">
        @if (categoriesWithMissingDefectSeverityDetailsCollapsed) {
          <span class="me-1" translate>Details anzeigen</span>
        }
        @if (!categoriesWithMissingDefectSeverityDetailsCollapsed) {
          <span class="me-1" translate>Details ausblenden</span>
        }
        <i
          class="fas"
          [ngClass]="{
            'fa-chevron-circle-down': categoriesWithMissingDefectSeverityDetailsCollapsed,
            'fa-chevron-circle-up': !categoriesWithMissingDefectSeverityDetailsCollapsed,
          }"></i>
      </button>
      <div
        [ngbCollapse]="categoriesWithMissingDefectSeverityDetailsCollapsed"
        id="collapse-missing-severity-details">
        <h6 class="mt-1" translate>Rubriken mit fehlendem Schweregrad</h6>
        @for (category of categoriesWithMissingDefectSeverity; track category) {
          <div class="mt-1">
            <span
              >{{ getCategoryName(category.categoryNumber) | i18nText }} -
              {{ getCategoryShortName(category.categoryNumber) | i18nText }}</span
            >
          </div>
        }
      </div>
    </div>
  }
  @if (showNotDefinedPointsMap()) {
    <div class="mb-2">
      <div
        class="multiline"
        translate="ConfirmStatusChangeMessageUndefinedPoints"
        [translateParams]="{ number: getNumberOfUndefinedPoints() }"></div>
      <button
        class="btn btn-link btn-details-toggle"
        (click)="undefinedPointsDetailsCollapsed = !undefinedPointsDetailsCollapsed"
        aria-expanded="!undefinedPointsDetailsCollapsed"
        aria-controls="collapse-undefined-points-details">
        @if (undefinedPointsDetailsCollapsed) {
          <span class="me-1" translate>Details anzeigen</span>
        }
        @if (!undefinedPointsDetailsCollapsed) {
          <span class="me-1" translate>Details ausblenden</span>
        }
        <i
          class="fas"
          [ngClass]="{
            'fa-chevron-circle-down': undefinedPointsDetailsCollapsed,
            'fa-chevron-circle-up': !undefinedPointsDetailsCollapsed,
          }"></i>
      </button>
      <div [ngbCollapse]="undefinedPointsDetailsCollapsed" id="collapse-undefined-points-details">
        <h6 class="mt-1" translate>Übersicht der nicht beurteilten Punkte</h6>
        @for (categoryPoints of notDefinedPointsMap | keyvalue; track categoryPoints) {
          <div class="mt-1">
            <span
              >{{ getCategoryName(categoryPoints.key) | i18nText }} -
              {{ getCategoryShortName(categoryPoints.key) | i18nText }} ({{
                categoryPoints.value.length
              }})</span
            >
          </div>
        }
      </div>
    </div>
  }
  @if (
    (!furtherActionSelectionValid || categoriesWithMissingDefectSeverity?.length) &&
    categoriesWithMissingDefectDescription?.length
  ) {
    <hr />
  }
  @if (categoriesWithMissingDefectDescription?.length) {
    <div class="mb-2">
      <div
        class="multiline"
        [translateParams]="{ number: categoriesWithMissingDefectDescription.length }"
        translate="ConfirmStatusChangeMessageCategoriesWithMissingDefectDescription"></div>
      <button
        class="btn btn-link btn-details-toggle"
        (click)="
          categoriesWithMissingDefectDescriptionDetailsCollapsed =
            !categoriesWithMissingDefectDescriptionDetailsCollapsed
        "
        aria-expanded="!categoriesWithMissingDefectDescriptionDetailsCollapsed"
        aria-controls="collapse-missing-severity-details">
        @if (categoriesWithMissingDefectDescriptionDetailsCollapsed) {
          <span class="me-1" translate>Details anzeigen</span>
        }
        @if (!categoriesWithMissingDefectDescriptionDetailsCollapsed) {
          <span class="me-1" translate>Details ausblenden</span>
        }
        <i
          class="fas"
          [ngClass]="{
            'fa-chevron-circle-down': categoriesWithMissingDefectDescriptionDetailsCollapsed,
            'fa-chevron-circle-up': !categoriesWithMissingDefectDescriptionDetailsCollapsed,
          }"></i>
      </button>
      <div
        [ngbCollapse]="categoriesWithMissingDefectDescriptionDetailsCollapsed"
        id="collapse-missing-severity-details">
        <h6 class="mt-1" translate>Rubriken mit fehlender Mangelbeschreibung</h6>
        @for (category of categoriesWithMissingDefectDescription; track category) {
          <div class="mt-1">
            <span
              >{{ getCategoryName(category.categoryNumber) | i18nText }} -
              {{ getCategoryShortName(category.categoryNumber) | i18nText }}</span
            >
          </div>
        }
      </div>
    </div>
  }
  @if (
    (!furtherActionSelectionValid ||
      categoriesWithMissingDefectSeverity?.length ||
      categoriesWithMissingDefectDescription?.length) &&
    categoriesWithMissingSanctionDescription?.length
  ) {
    <hr />
  }
  @if (categoriesWithMissingSanctionDescription?.length) {
    <div class="mb-2">
      <div
        class="multiline"
        [translateParams]="{ number: categoriesWithMissingSanctionDescription.length }"
        translate="ConfirmStatusChangeMessageCategoriesWithMissingSanctionDescription"></div>
      <button
        class="btn btn-link btn-details-toggle"
        (click)="
          categoriesWithMissingSanctionDescriptionDetailsCollapsed =
            !categoriesWithMissingSanctionDescriptionDetailsCollapsed
        "
        aria-expanded="!categoriesWithMissingSanctionDescriptionDetailsCollapsed"
        aria-controls="collapse-missing-severity-details">
        @if (categoriesWithMissingSanctionDescriptionDetailsCollapsed) {
          <span class="me-1" translate>Details anzeigen</span>
        }
        @if (!categoriesWithMissingSanctionDescriptionDetailsCollapsed) {
          <span class="me-1" translate>Details ausblenden</span>
        }
        <i
          class="fas"
          [ngClass]="{
            'fa-chevron-circle-down': categoriesWithMissingSanctionDescriptionDetailsCollapsed,
            'fa-chevron-circle-up': !categoriesWithMissingSanctionDescriptionDetailsCollapsed,
          }"></i>
      </button>
      <div
        [ngbCollapse]="categoriesWithMissingSanctionDescriptionDetailsCollapsed"
        id="collapse-missing-severity-details">
        <h6 class="mt-1" translate>Rubriken mit fehlendem Massnahmentext</h6>
        @for (category of categoriesWithMissingSanctionDescription; track category) {
          <div class="mt-1">
            <span
              >{{ getCategoryName(category.categoryNumber) | i18nText }} -
              {{ getCategoryShortName(category.categoryNumber) | i18nText }}</span
            >
          </div>
        }
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  @if (showNotDefinedPointsMap()) {
    <button type="button" class="btn btn-primary" (click)="setResultsToOK()" translate>
      Alle als OK markieren
    </button>
  }
  @if (showNotDefinedPointsMap()) {
    <button type="button" class="btn btn-primary" (click)="setResultsToNK()" translate>
      Alle als NK markieren
    </button>
  }
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="modal.dismiss()"
    appAutofocus
    translate>
    Abbrechen
  </button>
</div>
